import {
    createColumns,
    DataTableColumn,
} from '@/components/ui/data-table-customized'
import { generatePathDatacentral, paths } from '@/utils/path'
import { Link } from 'react-router-dom'
import { Employee } from '../types/response'
import EmployeeGender from '../components/Shared/EmployeeGender'
import EmployeeStatus from '../components/Shared/EmployeeStatus'
import dayjs from 'dayjs'

export const getEmployeeListColumns = (
    t: (key: string) => string
): DataTableColumn<Employee>[] =>
    createColumns<Employee>([
        {
            key: 'employee_code',
            title: t('employee_code'),
            width: 120,
            headerClassName: 'text-left',
            sortable: true,
            render: (value, row) => (
                <Link
                    to={generatePathDatacentral(paths.employeeUpdate, {
                        id: row.employee_id,
                    })}
                    className="text-primary hover:underline"
                >
                    {value}
                </Link>
            ),
        },
        {
            key: 'employee_name',
            title: t('employee_name'),
            width: 200,
            headerClassName: 'text-left',
            sortable: true,
        },
        {
            key: 'employee_status',
            title: t('employee_disable'),
            width: 150,
            headerClassName: 'text-center',
            cellClassName: 'text-center',
            sortable: true,
            render: (value) => <EmployeeStatus employee_status={value} />,
        },
        {
            key: 'department_name',
            title: t('department_id'),
            width: 180,
            headerClassName: 'text-left',
            sortable: true,
        },
        {
            key: 'position_name',
            title: t('position_id'),
            width: 180,
            headerClassName: 'text-left',
            sortable: true,
        },
        {
            key: 'employee_email_company',
            title: t('employee_email_company'),
            width: 220,
            headerClassName: 'text-left',
            cellClassName: 'truncate',
        },
        {
            key: 'employee_phone_number',
            title: t('employee_phone_number'),
            width: 130,
            headerClassName: 'text-left',
        },
        {
            key: 'employee_gender',
            title: t('employee_gender'),
            width: 100,
            headerClassName: 'text-center',
            cellClassName: 'text-center',
            render: (value) => <EmployeeGender employee_gender={value} />,
        },
        {
            key: 'employee_contract_type',
            title: t('employee_contract_type'),
            width: 120,
            headerClassName: 'text-center',
            cellClassName: 'text-center',
            sortable: true,
            render: (value) => {
                const typeMap: Record<string, string> = {
                    intern: t('Intern'),
                    collaborator: t('Collaborator'),
                    probation: t('Probation'),
                    official: t('Official'),
                    advisor: t('Advisor'),
                }
                return typeMap[value] || value
            },
        },
        {
            key: 'employee_seniority_level',
            title: t('employee_seniority_level'),
            width: 120,
            headerClassName: 'text-center',
            cellClassName: 'text-center capitalize',
            sortable: true,
            render: (value) => value || '',
        },
        {
            key: 'employee_start_date',
            title: t('employee_start_date'),
            width: 120,
            headerClassName: 'text-center',
            cellClassName: 'text-center',
            sortable: true,
            render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : ''),
        },
        {
            key: 'employee_email',
            title: t('employee_email'),
            width: 200,
            headerClassName: 'text-left',
            cellClassName: 'truncate',
        },
        {
            key: 'employee_birthday',
            title: t('employee_birthday'),
            width: 120,
            headerClassName: 'text-center',
            cellClassName: 'text-center',
            render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : ''),
        },
        {
            key: 'employee_day_off_left',
            title: t('employee_day_off_left'),
            width: 100,
            headerClassName: 'text-center',
            cellClassName: 'text-center',
        },
        {
            key: 'is_collaborator',
            title: t('is_collaborator'),
            width: 120,
            headerClassName: 'text-center',
            cellClassName: 'text-center',
            sortable: true,
            render: (value) => (
                <span className={value ? 'text-blue-600' : 'text-gray-400'}>
                    {value ? t('yes') : t('no')}
                </span>
            ),
        },
        {
            key: 'probation_date',
            title: t('probation_date'),
            width: 130,
            headerClassName: 'text-center',
            cellClassName: 'text-center',
            sortable: true,
            render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : ''),
        },
    ])
